// @flow
import type { ActionType } from '../types/actions';

export const TOGGLE_UI_STATE = 'TOGGLE_UI_STATE';

export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
export const ADD_TO_SELECTED_ITEMS = 'ADD_TO_SELECTED_ITEMS';
export const REMOVE_FROM_SELECTED_ITEMS = 'REMOVE_FROM_SELECTED_ITEMS';
export const TOGGLE_SELECTED_ITEM = 'TOGGLE_SELECTED_ITEM';

export function toggleUIState(name: string): ActionType {
  return { type: TOGGLE_UI_STATE, name };
}

export function setSelectedItems(modelIdMapping: { [string]: Array<number> }): ActionType {
  return { type: SET_SELECTED_ITEMS, modelIdMapping };
}
export function selectItem(modelType: string, id: number): ActionType {
  return setSelectedItems({ [modelType]: [id] });
}

export function addToSelectedItems(modelType: string, id: number): ActionType {
  return { type: ADD_TO_SELECTED_ITEMS, modelType, id };
}

export function removeFromSelectedItems(modelType: string, id: number): ActionType {
  return { type: REMOVE_FROM_SELECTED_ITEMS, modelType, id };
}

export function toggleSelectedItem(modelType: string, id: number): ActionType {
  return { type: TOGGLE_SELECTED_ITEM, modelType, id };
}

export function clearSelectedItems(): ActionType {
  return setSelectedItems({});
}



// WEBPACK FOOTER //
// ./src/actions/ui.js